__turbopack_context__.v({
  "page-body-wrap": "_0jAOba_page-body-wrap",
  "paragraph-content": "_0jAOba_paragraph-content",
  "wrap-container": "_0jAOba_wrap-container",
  "wrap-content": "_0jAOba_wrap-content",
});
